(function () {
  'use strict';

  if (window.SNSmartProductTabs) {
    window.SNSmartProductTabs.initAll();
    return;
  }

  var instances = new Map();
  var CACHE_PREFIX = 'sn-smart-tabs:v2:';
  var CATEGORY_KEY = 'sn_smart_category_history';
  var DEFAULT_PREFERENCE_WEIGHTS = { recent: 35, category: 25, cart: 25, wishlist: 15 };
  var DEFAULT_EXPLORATION_WEIGHTS = { market: 40, new: 35, seasonal: 25 };

  function safeParse(value, fallback) {
    try { return JSON.parse(value); } catch (_) { return fallback; }
  }

  function storageGet(storage, key, fallback) {
    try { return safeParse(storage.getItem(key), fallback); } catch (_) { return fallback; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }

  function clearCaches() {
    try {
      for (var index = sessionStorage.length - 1; index >= 0; index -= 1) {
        var key = sessionStorage.key(index);
        if (key && key.indexOf(CACHE_PREFIX) === 0) sessionStorage.removeItem(key);
      }
    } catch (_) {}
  }

  function purgeOtherMarkets(marketKey) {
    var prefix = CACHE_PREFIX + marketKey + ':';
    try {
      for (var index = sessionStorage.length - 1; index >= 0; index -= 1) {
        var key = sessionStorage.key(index);
        if (key && key.indexOf(CACHE_PREFIX) === 0 && key.indexOf(prefix) !== 0) sessionStorage.removeItem(key);
      }
    } catch (_) {}
  }

  function unique(values) {
    var seen = new Set();
    return values.filter(function (value) {
      var key = String(value || '');
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function normalizedTerms(value) {
    if (Array.isArray(value)) return value.map(function (item) { return String(item).trim().toLowerCase(); }).filter(Boolean);
    return String(value || '').split(',').map(function (item) { return item.trim().toLowerCase(); }).filter(Boolean);
  }

  function eligibleProduct(product, tab) {
    if (!product || !product.id || Number(product.price) <= 0 || product.giftCard) return false;
    if (!tab.includeSoldOut && product.available === false) return false;
    var tags = normalizedTerms(product.tags);
    var collections = normalizedTerms(product.collections);
    if (tags.some(function (tag) { return ['hidden', 'hide-from-search', 'exclude-from-recommendations'].indexOf(tag) !== -1; })) return false;
    var excludedTags = normalizedTerms(tab.excludeTags);
    var excludedCollections = normalizedTerms(tab.excludeCollections);
    if (tags.some(function (tag) { return excludedTags.indexOf(tag) !== -1; })) return false;
    if (collections.some(function (handle) { return excludedCollections.indexOf(handle) !== -1; })) return false;
    return true;
  }

  function eligibleCard(card, tab) {
    if (!card) return false;
    if (Number(card.dataset.productPrice) <= 0 || card.dataset.productGiftCard === 'true') return false;
    if (!tab.includeSoldOut && card.dataset.productAvailable === 'false') return false;
    var tags = normalizedTerms(String(card.dataset.productTags || '').split('||'));
    var collections = normalizedTerms(String(card.dataset.productCollections || '').split('||'));
    var excludedTags = normalizedTerms(tab.excludeTags);
    var excludedCollections = normalizedTerms(tab.excludeCollections);
    if (tags.some(function (tag) { return ['hidden', 'hide-from-search', 'exclude-from-recommendations'].indexOf(tag) !== -1 || excludedTags.indexOf(tag) !== -1; })) return false;
    if (collections.some(function (handle) { return excludedCollections.indexOf(handle) !== -1; })) return false;
    return true;
  }

  function normalizeWeights(values, defaults, keys) {
    var source = values || {};
    var result = {};
    var total = 0;
    keys.forEach(function (key) {
      var value = Math.max(0, Number(source[key]) || 0);
      result[key] = value;
      total += value;
    });
    if (total <= 0) return result;
    keys.forEach(function (key) { result[key] = result[key] / total; });
    return result;
  }

  function hash(value) {
    var output = 2166136261;
    var input = String(value || '');
    for (var index = 0; index < input.length; index += 1) {
      output ^= input.charCodeAt(index);
      output = Math.imul(output, 16777619);
    }
    return (output >>> 0) / 4294967295;
  }

  function sessionSeed(record, tab) {
    var key = CACHE_PREFIX + record.config.marketKey + ':seed:' + record.config.sectionId + ':' + tab.id;
    var seed = storageGet(sessionStorage, key, null);
    if (typeof seed !== 'number') {
      seed = Math.floor(Math.random() * 1000000000);
      storageSet(sessionStorage, key, seed);
    }
    return seed;
  }

  function categoryHistory() {
    return storageGet(localStorage, CATEGORY_KEY, {});
  }

  function rememberCategory(handle) {
    var normalized = String(handle || '').trim().toLowerCase();
    if (!normalized) return;
    var history = categoryHistory();
    history[normalized] = Math.min(50, (Number(history[normalized]) || 0) + 1);
    storageSet(localStorage, CATEGORY_KEY, history);
  }

  function collectionHandleFromUrl(value) {
    try {
      var url = new URL(value, location.href);
      if (url.origin !== location.origin) return '';
      var match = url.pathname.match(/\/collections\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  }

  function installCategoryTracking() {
    if (window.__snSmartCategoryTracking) return;
    window.__snSmartCategoryTracking = true;
    var referrerHandle = collectionHandleFromUrl(document.referrer);
    if (referrerHandle) rememberCategory(referrerHandle);
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/collections/"]');
      if (link) rememberCategory(collectionHandleFromUrl(link.href));
    }, true);
  }

  function emit(record, eventName, detail) {
    var payload = Object.assign({ event: eventName, section_id: record.config.sectionId }, detail || {});
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    record.root.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: payload }));
  }

  function tabById(record, id) {
    return record.config.tabs.find(function (tab) { return String(tab.id) === String(id); });
  }

  function productsById(products) {
    var map = new Map();
    (products || []).forEach(function (product) { if (product && product.id) map.set(String(product.id), product); });
    return map;
  }

  function candidateProducts(tab) {
    var candidates = [];
    var seen = new Set();
    [tab.sourceProducts, tab.fallbackProducts, tab.newProducts, tab.seasonalProducts].forEach(function (pool) {
      (pool || []).forEach(function (product) {
        var id = String(product && product.id || '');
        if (!id || seen.has(id)) return;
        seen.add(id);
        candidates.push(product);
      });
    });
    return candidates;
  }

  function cartSignals(record) {
    if (record.cartPromise) return record.cartPromise;
    record.cartPromise = fetch(record.config.cartUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || []).map(function (item) { return { id: String(item.product_id || ''), handle: item.handle || '' }; });
      })
      .catch(function () { return []; });
    return record.cartPromise;
  }

  function scorePreferenceProducts(record, tab, cartItems) {
    var products = (tab.sourceProducts || []).filter(function (product) { return eligibleProduct(product, tab); });
    var recent = storageGet(localStorage, '_halo_recently_viewed', []).map(String);
    var wishlist = new Set(storageGet(localStorage, 'wishlistItem', []).map(String));
    var cartIds = new Set(cartItems.map(function (item) { return item.id; }));
    var cartHandles = new Set(cartItems.map(function (item) { return item.handle; }));
    var categories = categoryHistory();
    var values = tab.strategy === 'advanced' ? tab.weights : DEFAULT_PREFERENCE_WEIGHTS;
    var weights = normalizeWeights(values, DEFAULT_PREFERENCE_WEIGHTS, ['recent', 'category', 'cart', 'wishlist']);
    return products.map(function (product) {
      var recentIndex = recent.indexOf(String(product.id));
      var recentScore = recentIndex < 0 ? 0 : (recent.length - recentIndex) / Math.max(1, recent.length);
      var categoryScore = 0;
      normalizedTerms((product.collections || []).concat(product.tags || [])).forEach(function (term) {
        categoryScore += Number(categories[term]) || 0;
      });
      categoryScore = Math.min(1, categoryScore / 5);
      var cartScore = cartIds.has(String(product.id)) || cartHandles.has(product.handle) ? 1 : 0;
      var wishlistScore = wishlist.has(product.handle) ? 1 : 0;
      var score = recentScore * weights.recent + categoryScore * weights.category + cartScore * weights.cart + wishlistScore * weights.wishlist;
      return { product: product, score: score, tie: hash(product.id + ':' + sessionSeed(record, tab)) };
    }).filter(function (entry) { return entry.score > 0; }).sort(function (a, b) {
      return b.score - a.score || b.tie - a.tie;
    }).map(function (entry) { return entry.product; });
  }

  function explorationProducts(record, tab) {
    var values = tab.strategy === 'advanced' ? tab.weights : DEFAULT_EXPLORATION_WEIGHTS;
    var weights = normalizeWeights(values, DEFAULT_EXPLORATION_WEIGHTS, ['market', 'new', 'seasonal']);
    var seed = sessionSeed(record, tab);
    var scored = [];
    [
      { key: 'market', products: tab.fallbackProducts || [] },
      { key: 'new', products: tab.newProducts || [] },
      { key: 'seasonal', products: tab.seasonalProducts || [] }
    ].forEach(function (pool) {
      if (weights[pool.key] <= 0) return;
      pool.products.filter(function (product) { return eligibleProduct(product, tab); }).forEach(function (product, index) {
        scored.push({ product: product, score: weights[pool.key] / (index + 1), tie: hash(pool.key + ':' + product.id + ':' + seed) });
      });
    });
    scored.sort(function (a, b) { return b.score - a.score || b.tie - a.tie; });
    var seen = new Set();
    return scored.filter(function (entry) {
      var id = String(entry.product.id);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    }).map(function (entry) { return entry.product; });
  }

  function fillProducts(target, candidates, maximum) {
    var seen = new Set(target.map(function (product) { return String(product.id); }));
    candidates.some(function (product) {
      var id = String(product.id);
      if (!seen.has(id)) {
        target.push(product);
        seen.add(id);
      }
      return target.length >= maximum;
    });
    return target;
  }

  function personalizedIds(record, tab) {
    return cartSignals(record).then(function (cartItems) {
      var maximum = Number(tab.maxProducts) || 8;
      var preferred = scorePreferenceProducts(record, tab, cartItems);
      var exploration = explorationProducts(record, tab);
      var hasBehavior = preferred.length > 0;
      var preferenceRatio = Number(tab.preferenceRatio);
      if (!Number.isFinite(preferenceRatio)) preferenceRatio = 65;
      var preferenceTarget = hasBehavior ? Math.round(maximum * Math.max(0, Math.min(100, preferenceRatio)) / 100) : 0;
      var result = preferred.slice(0, preferenceTarget);
      fillProducts(result, exploration, maximum);
      fillProducts(result, preferred, maximum);
      var allFallback = [];
      [tab.fallbackProducts, tab.newProducts, tab.seasonalProducts, tab.sourceProducts].forEach(function (pool) {
        (pool || []).forEach(function (product) { if (eligibleProduct(product, tab)) allFallback.push(product); });
      });
      fillProducts(result, allFallback, maximum);
      emit(record, 'sn_for_you_load', { tab_name: tab.label, strategy: hasBehavior ? 'preference_mix' : 'market_fallback', market: record.config.marketKey, item_count: result.length });
      return result.slice(0, maximum).map(function (product) { return String(product.id); });
    });
  }

  function idsForTab(record, tab) {
    var maximum = Number(tab.maxProducts) || 8;
    if (tab.source === 'recently_viewed') {
      var recentIds = storageGet(localStorage, '_halo_recently_viewed', []).map(String);
      var recentFallback = [];
      [tab.fallbackProducts, tab.sourceProducts, tab.newProducts, tab.seasonalProducts].forEach(function (pool) {
        (pool || []).filter(function (product) { return eligibleProduct(product, tab); }).forEach(function (product) { recentFallback.push(String(product.id)); });
      });
      var knownIds = new Set(recentFallback);
      return Promise.resolve(unique(recentIds.filter(function (id) { return knownIds.has(id); }).concat(recentFallback)).slice(0, maximum));
    }
    if (tab.source === 'personalized') return personalizedIds(record, tab);
    var primaryIds = (tab.sourceProducts || []).filter(function (product) {
      return eligibleProduct(product, tab);
    }).map(function (product) { return String(product.id); });
    var fallbackIds = (tab.fallbackProducts || []).filter(function (product) {
      return eligibleProduct(product, tab);
    }).map(function (product) { return String(product.id); });
    return Promise.resolve(unique(primaryIds.concat(fallbackIds)).slice(0, maximum));
  }

  function namespaceIds(container, prefix) {
    var map = new Map();
    container.querySelectorAll('[id]').forEach(function (element) {
      var previous = element.id;
      var next = prefix + '-' + previous;
      map.set(previous, next);
      element.id = next;
    });
    ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach(function (attribute) {
      container.querySelectorAll('[' + attribute + ']').forEach(function (element) {
        var values = element.getAttribute(attribute).split(/\s+/).map(function (value) { return map.get(value) || value; });
        element.setAttribute(attribute, values.join(' '));
      });
    });
    container.querySelectorAll('[href^="#"], [data-modal^="#"]').forEach(function (element) {
      ['href', 'data-modal'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (!value || value.charAt(0) !== '#') return;
        var mapped = map.get(value.slice(1));
        if (mapped) element.setAttribute(attribute, '#' + mapped);
      });
    });
  }

  function addBadge(card, tab, labels) {
    if (!tab.showBadge || card.querySelector('.sn-px-card__tags')) return;
    var label = '';
    if (card.dataset.productAvailable === 'false') label = labels.soldOut;
    else if (card.dataset.productOnSale === 'true') label = labels.sale;
    else label = tab.badgeLabel || '';
    if (!label) return;
    var media = card.querySelector('.sn-px-card__media');
    if (!media) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'sn-px-card__tags';
    wrapper.setAttribute('aria-label', label);
    var badge = document.createElement('span');
    badge.textContent = label;
    wrapper.appendChild(badge);
    media.insertBefore(wrapper, media.firstChild);
  }

  function queryTitle(value) {
    return 'title:"' + String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  function collectFeedCards(text, cards) {
    var documentNode = new DOMParser().parseFromString(text, 'text/html');
    var feed = documentNode.querySelector('[data-sn-smart-feed]');
    if (!feed) throw new Error('feed-missing');
    feed.querySelectorAll('[data-sn-product-card]').forEach(function (card) {
      cards.set(String(card.dataset.productId || ''), card);
    });
  }

  function fetchFeed(url, signal) {
    var controller = new AbortController();
    var onAbort = function () { controller.abort(); };
    if (signal) signal.addEventListener('abort', onAbort, { once: true });
    if (signal && signal.aborted) controller.abort();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    return fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('feed-' + response.status);
        return response.text();
      }).finally(function () {
        clearTimeout(timeout);
        if (signal) signal.removeEventListener('abort', onAbort);
      });
  }

  function applyCardOptions(card, options) {
    if (!options) return;
    function remove(selector) {
      card.querySelectorAll(selector).forEach(function (node) { node.remove(); });
    }
    if (!options.showRating) remove('.jdgm-widget');
    if (!options.showPrice) remove('.sn-px-card__price');
    else if (!options.showComparePrice) remove('.price__sale .price-item--regular, .price__sale .price-item--percent');
    if (!options.showSwatches) remove('.sn-px-card__swatches');
    if (!options.showVendor) remove('.sn-px-card__vendor');
    if (!options.enableWishlist) card.querySelectorAll('[data-wishlist]').forEach(function (node) { var item = node.closest('.card-product__group-item'); (item || node).remove(); });
    if (!options.enableQuickView) card.querySelectorAll('.quickview-button').forEach(function (node) { var item = node.closest('.card-product__group-item'); (item || node).remove(); });
    if (!options.enableQuickAdd) remove('.sn-px-card__quick-add');
    card.querySelectorAll('.sn-px-card__actions').forEach(function (actions) { if (!actions.children.length) actions.remove(); });
  }

  function appendViewAllCard(output, record, tab) {
    var url = tab.viewAllUrl || record.config.globalViewAllUrl || '';
    if (!record.config.showViewAllCard || !url || !tab.label) return;
    var item = document.createElement('li');
    item.className = 'sn-smart-tabs__view-card';
    item.dataset.snSmartViewCard = '';
    var link = document.createElement('a');
    link.className = 'sn-smart-tabs__view-card-link';
    link.href = url;
    link.dataset.snSmartEndLink = '';
    var inner = document.createElement('span');
    inner.className = 'sn-smart-tabs__view-card-inner';
    var kicker = document.createElement('span');
    kicker.className = 'sn-smart-tabs__view-card-kicker';
    kicker.textContent = record.config.labels.viewAll || 'View all';
    var title = document.createElement('span');
    title.className = 'sn-smart-tabs__view-card-title';
    title.textContent = tab.label;
    var arrow = document.createElement('span');
    arrow.className = 'sn-smart-tabs__view-card-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    inner.appendChild(kicker);
    inner.appendChild(title);
    inner.appendChild(arrow);
    link.appendChild(inner);
    item.appendChild(link);
    output.appendChild(item);
  }

  function buildCardHTML(record, tab, cards, ids) {
    var output = document.createElement('div');
    var rendered = 0;
    ids.forEach(function (id, index) {
      if (rendered >= (Number(tab.maxProducts) || 8)) return;
      var sourceCard = cards.get(String(id));
      if (!sourceCard || !eligibleCard(sourceCard, tab)) return;
      var item = document.createElement('li');
      item.className = 'sn-smart-tabs__item';
      item.dataset.snSmartItem = '';
      item.dataset.productId = String(id);
      var card = sourceCard.cloneNode(true);
      applyCardOptions(card, record.config.cardOptions);
      addBadge(card, tab, record.config.labels);
      item.appendChild(card);
      namespaceIds(item, 'SNSmart-' + record.config.sectionId + '-' + tab.id + '-' + index);
      output.appendChild(item);
      rendered += 1;
    });
    if (!rendered) throw new Error('feed-empty');
    appendViewAllCard(output, record, tab);
    return output.innerHTML;
  }

  function fetchCollectionCards(record, tab) {
    var ready = window.SNMarket && typeof window.SNMarket.ready === 'function' ? window.SNMarket.ready() : Promise.resolve(true);
    var cards = new Map();
    function addCollection(url) {
      var feedUrl = new URL(url, location.origin);
      feedUrl.searchParams.set('view', 'sn-smart-feed');
      return fetchFeed(feedUrl, record.controller.signal).then(function (text) { collectFeedCards(text, cards); });
    }
    return ready.then(function (valid) {
      if (valid === false) throw new Error('market-invalidated');
      return addCollection(tab.collectionFeedUrl);
    }).then(function () {
      if (cards.size >= (Number(tab.maxProducts) || 8) || !tab.fallbackCollectionFeedUrl || tab.fallbackCollectionFeedUrl === tab.collectionFeedUrl) return;
      return addCollection(tab.fallbackCollectionFeedUrl);
    }).then(function () { return buildCardHTML(record, tab, cards, Array.from(cards.keys())); });
  }

  function fetchCards(record, tab, ids) {
    if (!ids.length) return Promise.resolve('');
    var products = productsById(candidateProducts(tab));
    var requested = ids.map(function (id) { return products.get(String(id)); }).filter(Boolean);
    if (!requested.length) return Promise.resolve('');
    var ready = window.SNMarket && typeof window.SNMarket.ready === 'function' ? window.SNMarket.ready() : Promise.resolve(true);
    return ready.then(function (valid) {
      if (valid === false) throw new Error('market-invalidated');
      var cards = new Map();
      var batchUrl = new URL(record.config.searchUrl, location.origin);
      batchUrl.searchParams.set('view', 'sn-smart-feed');
      batchUrl.searchParams.set('type', 'product');
      batchUrl.searchParams.set('q', requested.map(function (product) { return queryTitle(product.title); }).join(' OR '));
      return fetchFeed(batchUrl, record.controller.signal).then(function (text) {
        collectFeedCards(text, cards);
      }).catch(function () {}).then(function () {
        var missing = requested.filter(function (product) { return !cards.has(String(product.id)); });
        return Promise.all(missing.map(function (product) {
          var path = String(record.config.rootUrl || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(product.handle);
          var productUrl = new URL(path, location.origin);
          productUrl.searchParams.set('view', 'sn-smart-card');
          return fetchFeed(productUrl, record.controller.signal).then(function (text) { collectFeedCards(text, cards); }).catch(function () {});
        })).then(function () { return cards; });
      });
    }).then(function (cards) { return buildCardHTML(record, tab, cards, ids); });
  }

  function skeletonHTML(record) {
    var count = Math.max(4, Number(getComputedStyle(record.root).getPropertyValue('--sn-smart-columns')) || 5);
    var html = '';
    for (var index = 0; index < count; index += 1) html += '<li class="sn-smart-tabs__skeleton" aria-hidden="true"></li>';
    return html;
  }

  function showLoading(record, panel) {
    var list = panel.querySelector('[data-sn-smart-products]');
    var status = panel.querySelector('[data-sn-smart-status]');
    if (list) list.innerHTML = skeletonHTML(record);
    if (status) status.textContent = record.config.labels.loading;
  }

  function showEmpty(record, panel) {
    var list = panel.querySelector('[data-sn-smart-products]');
    var status = panel.querySelector('[data-sn-smart-status]');
    if (list) list.innerHTML = '<li class="sn-smart-tabs__empty" data-sn-smart-empty></li>';
    var empty = list && list.querySelector('[data-sn-smart-empty]');
    if (empty) empty.textContent = record.config.labels.empty;
    if (status) status.textContent = '';
  }

  function showError(record, panel, tab) {
    var status = panel.querySelector('[data-sn-smart-status]');
    if (!status) return;
    status.textContent = '';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sn-smart-tabs__retry';
    button.dataset.snSmartRetry = tab.id;
    button.textContent = record.config.labels.retry;
    status.appendChild(button);
  }

  function hydrateIntegrations(record, panel, tab) {
    panel.querySelectorAll('img').forEach(function (image) { if (!image.hasAttribute('loading')) image.loading = 'lazy'; });
    try { if (typeof window.initMoreSwatchButtons === 'function') window.initMoreSwatchButtons(panel); } catch (_) {}
    try { if (typeof window.initWishlistFromLocalStorage === 'function') window.initWishlistFromLocalStorage(); } catch (_) {}
    try {
      if (window.jdgm && window.jdgm.widgetManager && typeof window.jdgm.widgetManager.initWidgets === 'function') window.jdgm.widgetManager.initWidgets();
      else if (window.jdgm && typeof window.jdgm.refreshBadges === 'function') window.jdgm.refreshBadges();
    } catch (_) {}
    setupImpressions(record, panel, tab);
    document.dispatchEvent(new CustomEvent('sn:dynamic-products', { detail: { sectionId: record.config.sectionId, tabId: tab.id } }));
  }

  function scheduleHydration(record, panel, tab) {
    if (record.hydrated.has(tab.id)) return;
    record.hydrated.add(tab.id);
    requestAnimationFrame(function () {
      setTimeout(function () {
        if (!record.controller.signal.aborted) hydrateIntegrations(record, panel, tab);
      }, 0);
    });
  }

  function prewarmImages(record, panel) {
    if (!panel.hidden || (navigator.connection && navigator.connection.saveData)) return;
    var run = function () {
      if (record.controller.signal.aborted) return;
      var count = matchMedia('(max-width: 749px)').matches ? 2 : 4;
      Array.prototype.slice.call(panel.querySelectorAll('.sn-px-card__image--primary'), 0, count).forEach(function (image) {
        if (!image.src) return;
        var warm = new Image();
        warm.fetchPriority = 'low';
        warm.sizes = image.sizes;
        warm.srcset = image.srcset;
        warm.src = image.src;
        record.imageWarmers.push(warm);
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1800 });
    else setTimeout(run, 150);
  }

  function renderHTML(record, tab, html) {
    var panel = record.root.querySelector('[data-sn-smart-panel="' + tab.id + '"]');
    if (!panel || record.controller.signal.aborted) return;
    var list = panel.querySelector('[data-sn-smart-products]');
    var status = panel.querySelector('[data-sn-smart-status]');
    if (!html) {
      showEmpty(record, panel);
      record.loaded.add(tab.id);
      return;
    }
    list.innerHTML = html;
    if (status) status.textContent = '';
    record.loaded.add(tab.id);
    if (panel.hidden) prewarmImages(record, panel);
    else {
      scheduleHydration(record, panel, tab);
      updateNavigation(record);
    }
  }

  function loadTab(record, tab, prefetch) {
    if (record.loaded.has(tab.id)) return Promise.resolve();
    var panel = record.root.querySelector('[data-sn-smart-panel="' + tab.id + '"]');
    if (!prefetch && panel) showLoading(record, panel);
    if (record.pending.has(tab.id)) return record.pending.get(tab.id);
    var marketGeneration = record.marketGeneration;
    var source = tab.collectionFeedUrl ? fetchCollectionCards(record, tab) : idsForTab(record, tab).then(function (ids) {
      return fetchCards(record, tab, ids);
    });
    var task = source.then(function (html) {
      if (marketGeneration !== record.marketGeneration) throw new Error('market-invalidated');
      renderHTML(record, tab, html);
    }).catch(function (error) {
      if (record.controller.signal.aborted || (error && error.message === 'market-invalidated')) return;
      if (panel && !panel.hidden) showError(record, panel, tab);
    }).finally(function () { record.pending.delete(tab.id); });
    record.pending.set(tab.id, task);
    return task;
  }

  function activeList(record) {
    return record.root.querySelector('[data-sn-smart-panel]:not([hidden]) [data-sn-smart-products]');
  }

  function updateNavigation(record) {
    var list = activeList(record);
    var previous = record.root.querySelector('[data-sn-smart-previous]');
    var next = record.root.querySelector('[data-sn-smart-next]');
    if (!list) return;
    var max = Math.max(0, list.scrollWidth - list.clientWidth);
    if (previous) previous.disabled = max <= 2 || list.scrollLeft <= 2;
    if (next) next.disabled = max <= 2 || list.scrollLeft >= max - 2;
  }

  function moveProducts(record, direction) {
    var list = activeList(record);
    if (!list) return;
    var item = list.querySelector('[data-sn-smart-item], .sn-smart-tabs__skeleton');
    var amount = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap || 0) : list.clientWidth;
    list.scrollBy({ left: direction * amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function activate(record, id, focusTab) {
    var tab = tabById(record, id);
    if (!tab) return;
    var previousTab = tabById(record, record.activeTab);
    record.activeTab = tab.id;
    record.root.querySelectorAll('[data-sn-smart-tab]').forEach(function (button) {
      var active = button.dataset.snSmartTab === tab.id;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
      if (active && focusTab) button.focus({ preventScroll: true });
    });
    record.root.querySelectorAll('[data-sn-smart-panel]').forEach(function (panel) {
      var active = panel.dataset.snSmartPanel === tab.id;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    if (record.loaded.has(tab.id)) {
      var readyPanel = record.root.querySelector('[data-sn-smart-panel="' + tab.id + '"]');
      if (readyPanel) scheduleHydration(record, readyPanel, tab);
    } else loadTab(record, tab, false);
    updateNavigation(record);
    if (!record.viewedTabs.has(tab.id)) {
      record.viewedTabs.add(tab.id);
      emit(record, 'sn_tab_view', { tab_name: tab.label, source_type: tab.source });
    }
    if (previousTab && previousTab.id !== tab.id) emit(record, 'sn_tab_click', { from_tab: previousTab.label, to_tab: tab.label });
  }

  function setupImpressions(record, panel, tab) {
    if (!('IntersectionObserver' in window)) return;
    panel.querySelectorAll('[data-sn-smart-item]:not([data-sn-impression-bound])').forEach(function (item, position) {
      item.dataset.snImpressionBound = 'true';
      record.impressionObserver.observe(item);
      item.dataset.snTabName = tab.label;
      item.dataset.snPosition = String(position + 1);
    });
  }

  function handleProductEvent(record, target, kind) {
    var item = target.closest('[data-sn-smart-item]');
    var panel = target.closest('[data-sn-smart-panel]');
    var tab = panel && tabById(record, panel.dataset.snSmartPanel);
    var card = item && item.querySelector('[data-sn-product-card]');
    if (!item || !tab || !card) return;
    if (kind === 'sn_product_click') {
      normalizedTerms(String(card.dataset.productCollections || '').split('||')).forEach(rememberCategory);
    }
    emit(record, kind, { tab_name: tab.label, product_id: card.dataset.productId, position: Array.prototype.indexOf.call(item.parentNode.children, item) + 1 });
  }

  function openQuickAddSheet() {
    document.documentElement.classList.add('sn-shoppable-quickadd-active');
    window.setTimeout(function () {
      var modal = document.getElementById('QuickAddStandard');
      if (!modal || modal.dataset.snSmartSheetObserved === 'true') return;
      modal.dataset.snSmartSheetObserved = 'true';
      new MutationObserver(function () {
        if (!modal.hasAttribute('open')) document.documentElement.classList.remove('sn-shoppable-quickadd-active');
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }, 0);
  }

  function installQuickAddCleanup() {
    if (window.__snSmartQuickAddCleanup) return;
    window.__snSmartQuickAddCleanup = true;
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') document.documentElement.classList.remove('sn-shoppable-quickadd-active');
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('#QuickAddStandard .quick-add-modal__toggle, #QuickAddStandard #Modal-Overlay')) {
        document.documentElement.classList.remove('sn-shoppable-quickadd-active');
      }
    });
    if (document.body) document.body.addEventListener('modalClosed', function () {
      document.documentElement.classList.remove('sn-shoppable-quickadd-active');
    });
  }

  function bind(record) {
    var signal = record.controller.signal;
    record.root.addEventListener('click', function (event) {
      var tabButton = event.target.closest('[data-sn-smart-tab]');
      if (tabButton) { event.preventDefault(); activate(record, tabButton.dataset.snSmartTab, false); return; }
      var retry = event.target.closest('[data-sn-smart-retry]');
      if (retry) {
        event.preventDefault();
        var tab = tabById(record, retry.dataset.snSmartRetry);
        if (tab) loadTab(record, tab, false);
        return;
      }
      if (event.target.closest('[data-sn-smart-previous]')) { event.preventDefault(); moveProducts(record, -1); return; }
      if (event.target.closest('[data-sn-smart-next]')) { event.preventDefault(); moveProducts(record, 1); return; }
      var endLink = event.target.closest('[data-sn-smart-end-link]');
      if (endLink) {
        var endPanel = endLink.closest('[data-sn-smart-panel]');
        var endTab = endPanel && tabById(record, endPanel.dataset.snSmartPanel);
        if (endTab) emit(record, 'sn_view_all_click', { tab_name: endTab.label, source_type: endTab.source });
        return;
      }
      if (event.target.closest('.sn-px-card__quick-add modal-opener')) openQuickAddSheet();
      if (event.target.closest('[data-wishlist]')) handleProductEvent(record, event.target, 'sn_wishlist');
      else if (event.target.closest('.quickview-button')) handleProductEvent(record, event.target, 'sn_quick_view');
      else if (event.target.closest('.sn-px-card__image-link, .sn-px-card__title a')) handleProductEvent(record, event.target, 'sn_product_click');
    }, { signal: signal });
    record.root.addEventListener('submit', function (event) {
      if (event.target.closest('.sn-px-card__quick-add')) handleProductEvent(record, event.target, 'sn_add_to_cart');
    }, { signal: signal });
    record.root.addEventListener('keydown', function (event) {
      var button = event.target.closest('[data-sn-smart-tab]');
      if (!button || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
      event.preventDefault();
      var buttons = Array.prototype.slice.call(record.root.querySelectorAll('[data-sn-smart-tab]'));
      var current = buttons.indexOf(button);
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      activate(record, buttons[next].dataset.snSmartTab, true);
    }, { signal: signal });
    record.root.addEventListener('scroll', function (event) {
      if (!event.target.matches('[data-sn-smart-products]')) return;
      cancelAnimationFrame(record.scrollFrame);
      record.scrollFrame = requestAnimationFrame(function () { updateNavigation(record); });
    }, { passive: true, capture: true, signal: signal });
  }

  function prefetch(record) {
    var run = function () {
      if (record.prefetchStarted || record.controller.signal.aborted) return;
      record.prefetchStarted = true;
      if (record.prefetchObserver) record.prefetchObserver.disconnect();
      var active = tabById(record, record.activeTab);
      var activePanel = active && record.root.querySelector('[data-sn-smart-panel="' + active.id + '"]');
      if (activePanel && record.loaded.has(active.id)) scheduleHydration(record, activePanel, active);
      var tabs = record.config.tabs.filter(function (tab) { return tab.id !== record.config.defaultTab; });
      var index = 0;
      var next = function () {
        if (index >= tabs.length || record.controller.signal.aborted) return Promise.resolve();
        var tab = tabs[index++];
        return loadTab(record, tab, true).then(next, next);
      };
      next();
      next();
    };
    if (window.Shopify && window.Shopify.designMode) { run(); return; }
    if ('IntersectionObserver' in window) {
      record.prefetchObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) run();
      }, { rootMargin: '1000px 0px' });
      record.prefetchObserver.observe(record.root);
    } else {
      var check = function () {
        var bounds = record.root.getBoundingClientRect();
        if (bounds.top > innerHeight + 1000 || bounds.bottom < -1000) return;
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
        run();
      };
      window.addEventListener('scroll', check, { passive: true, signal: record.controller.signal });
      window.addEventListener('resize', check, { passive: true, signal: record.controller.signal });
      check();
    }
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    var configNode = root.querySelector('[data-sn-smart-config]');
    var config = configNode && safeParse(configNode.textContent, null);
    if (!config || !Array.isArray(config.tabs) || !config.tabs.length) return;
    purgeOtherMarkets(config.marketKey);
    var record = {
      root: root,
      config: config,
      activeTab: config.defaultTab,
      loaded: new Set(),
      hydrated: new Set(),
      pending: new Map(),
      viewedTabs: new Set(),
      controller: new AbortController(),
      marketGeneration: 0,
      cartPromise: null,
      prefetchObserver: null,
      prefetchStarted: false,
      imageWarmers: [],
      scrollFrame: 0
    };
    record.impressionObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        record.impressionObserver.unobserve(entry.target);
        emit(record, 'sn_product_impression', { tab_name: entry.target.dataset.snTabName, product_id: entry.target.dataset.productId, position: Number(entry.target.dataset.snPosition) || 0 });
      });
    }, { threshold: [0.5] }) : null;
    instances.set(root, record);
    installCategoryTracking();
    installQuickAddCleanup();
    bind(record);
    var activePanel = root.querySelector('[data-sn-smart-panel="' + config.defaultTab + '"]');
    var activeTab = tabById(record, config.defaultTab);
    if (activePanel && activeTab && activePanel.querySelector('[data-sn-smart-item], [data-sn-smart-empty]')) {
      record.loaded.add(activeTab.id);
    } else if (activeTab) {
      loadTab(record, activeTab, false);
    }
    if (activeTab) {
      record.viewedTabs.add(activeTab.id);
      emit(record, 'sn_tab_view', { tab_name: activeTab.label, source_type: activeTab.source });
    }
    updateNavigation(record);
    prefetch(record);
  }

  function dispose(root) {
    var record = instances.get(root);
    if (!record) return;
    record.controller.abort();
    record.impressionObserver && record.impressionObserver.disconnect();
    record.prefetchObserver && record.prefetchObserver.disconnect();
    record.imageWarmers.length = 0;
    cancelAnimationFrame(record.scrollFrame);
    instances.delete(root);
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-sn-smart-tabs]')) init(context);
    if (context.querySelectorAll) context.querySelectorAll('[data-sn-smart-tabs]').forEach(init);
  }

  window.SNSmartProductTabs = { init: init, initAll: initAll, clearCaches: clearCaches };
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-sn-smart-tabs]') ? event.target : event.target.querySelector && event.target.querySelector('[data-sn-smart-tabs]');
    if (root) dispose(root);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    instances.forEach(function (record) { if (tabById(record, blockId)) activate(record, blockId, false); });
  });
  function invalidateMarket() {
    clearCaches();
    instances.forEach(function (record) { record.marketGeneration += 1; });
  }
  document.addEventListener('sn:market-change', invalidateMarket);
  document.addEventListener('sn:market-invalidated', invalidateMarket);
  window.addEventListener('resize', function () { instances.forEach(updateNavigation); }, { passive: true });
  initAll();
})();
